import { Box, CircularProgress } from '@material-ui/core';
import {
  useParams, Redirect,
} from "react-router-dom";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { signIn } from '../redux/AccountRedux';
import { closeOverlayAndReset, openOverlay as openOverlayEditView, setValues } from '../redux/UIOverlayMeasurementEditViewRedux';
import { CartStateItem } from 'common-ts/dist/models/Cart';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { fetchUserItemQRSize } from '../redux/MeasurementsRedux';
import { itemCategoriesClothingType, itemCategoriesFitType } from './OverlayViewPersonalSizeDetail';
import { openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';
import { sendWebsiteLivestreamMessage } from '../telegrambotevents';

export default function PageCreatePersonalSize() {
  let { userItemQRSizeId } = useParams<{ userItemQRSizeId: string }>();
  const userAcc = useAppSelector(state => state.account);
  const isSignedIn = useAppSelector(state => state.account.authState === 'signedin');
  const dispatch = useAppDispatch();

  // const currentUserItemQRSizeId = useAppSelector(state => state.userMeasurementsList.userItemQRSizeId);
  // const currentUserItemQRSize = useAppSelector(state => state.userMeasurementsList.userItemQRSize); // userMeasurementsForItem
  // const currentUserItemQRCartProductItem: CartStateItem = useAppSelector( state => state.userMeasurementsList.userItemQRCartProductItem); // cartProductItem

  // const productDict = useAppSelector(state => state.productsList.productsDictionary);

  const orderIdFull = userItemQRSizeId.substring(0, 50);
  const orderId = userItemQRSizeId.substring(0, 36);
  const userSubAndItemNumber = userItemQRSizeId.substring(25);
  const userSub = userSubAndItemNumber.substring(0, userSubAndItemNumber.length - 5);
  const itemNumber = Number(userSubAndItemNumber.slice(-4));

  // 01. Auto sign in on non-trivial userSub
  useEffect(() => {

    // START HOTJAR RECORDING
    (window as any).hj('event', 'start_hotjar_rec');
    (window as any).hj('event', 'event_recording_sizing');
    console.log("START-HOTJAR-REC");
    sendWebsiteLivestreamMessage('[HOTJAR REC - UX] STARTED - MAKE SIZE FROM OTHER');

    if (userSub && (!isSignedIn || userAcc.sub !== userSub)) {
      dispatch(signIn({ password: '123', useEmail: true, otpValue: '', subTempPass: 'skfajsakjf', userSub: userSub, orderItemId: userItemQRSizeId}));
    }
  }, [userSub]);

  // 02. We wait until sign in is completed
  if (!isSignedIn) {
    return (
    <Box style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress/>
    </Box>
    );
  }

  // 03. If the user is signed in and has purchased AND the item size has been fetched, we open the edit size flow, and redirect to shop page
  if (isSignedIn && orderId && itemNumber !== undefined) {
    dispatch(openUniversalSizeOverlay({ productOnUser: undefined, flowVariant: 'itemQrScan', flowInputVariables: {
      // ITEM IS ALREADY CHOSEN
      clothMeasSuggestionOrderIdItemNumber: orderId + '+' + itemNumber,
    }}));

    return (<Redirect to={"/shop"} />);
  }

  // PREVIOUS VERSION (SIZE EDIT)
  // if (isSignedIn && currentUserItemQRSizeId === userItemQRSizeId) {
  //   dispatch(closeOverlayAndReset());
  //   dispatch(setValues({
  //     overlayType: 'edit',
  //     clothingType: currentUserItemQRCartProductItem.clothingType,
  //     fitType: currentUserItemQRCartProductItem.fitType,
  //     isFullScreen: true,
  //     currentMeasurementObject: currentUserItemQRSize,
  //     productDetail: productDict[currentUserItemQRCartProductItem.productId],
  //     origin: 'qr'
  //   }))
  //   dispatch(openOverlayEditView());

  //   return (<Redirect to={"/shop"} />);
  // }

  // 04. If the user is signed in but has not purchased, we just return null / a blank page
  return (
    <Box style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CircularProgress/>
    </Box>
    );
}
